import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ToastController, LoadingController, Events, AlertController } from 'ionic-angular';
import { ServiceSidemenuProvider } from '../../providers/service-sidemenu/service-sidemenu';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { ServiceGvariableProvider } from '../../providers/service-gvariable/service-gvariable';
import * as Bcryptjs from "bcryptjs";
import { BindingFlags } from '@angular/compiler/src/core';

/**
 * Generated class for the A01LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface branchInfo{
  BRANCH_ID: number;
  BRANCH_NAME: string;
}

interface inventoryInfo{
};
interface inventoryLevelInfo{
};
interface userInfo{
};
interface userGrpAccessInfo{
};
interface paymentTypeInfo{
};
interface paymentSubTypeInfo{
};
interface cardInfo{
};


@IonicPage()
@Component({
  selector: 'page-a01-login',
  templateUrl: 'a01-login.html',
})
export class A01LoginPage {

  private todo : FormGroup;

  loading: any;
  Status: any;
  loginData = { USER_NAME:'', PASSWORD:'' };
  userBranchId: any = null;
  branchName: any = null;
  userId: any = null;
  userName: any = null;
  userActive: any = null;
  userGrpId: any = null;
  userGrpName: any = null;
  userCorpId: any = null;
  userCorpName: any = null;
  userAccessId: any = [];
  numberData:number = 0;

  overlayHidden: boolean = true;
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  inventoryArr: inventoryInfo[] = [];
  inventoryItems: inventoryInfo[] = [];
  inventoryLevelArr: inventoryLevelInfo[] = [];
  userArr: userInfo[] = [];
  userItems: userInfo[] = [];
  userData= [];
  userGrpAccessArr: userGrpAccessInfo[] = [];
  userGrpAccessItems: userGrpAccessInfo[] = [];
  userGrpAccessData= [];
  offlineBranchID: any;
  paymentTypeArr: paymentTypeInfo[] = [];
  paymentSubTypeArr: paymentSubTypeInfo[] = [];
  cardArr: cardInfo[] = [];
  temp_password: any ='';
  SO_NO: string;
  temp_SO_NO: string;
  SO_USER_ID: string;
  SO_SO_NO: string;
  SO_NO2: string;
  temp_SO_NO2: string;
  SO_SO_NO2: string;
  f_offlineData: any = 0;
  // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
  temp_SO_NO3: string;
  SO_SO_NO3: string;
  SO_NO3: string;
  // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added

  paymentData = { AMOUNT_TENDER:0, AMOUNT_CHANGE:'', CORP_CARD_NO:'', AUTH_NO:'',
                  DATETIME:'', PAYMENT_TYPE_ID:'',
                }
  salesData =   { SOL_DESC:'', QTY:0, UNIT_PRICE:'', DISC_PERC: '', TAX_PERC:'', TOTAL_TAX:'',
                  SOL_TOTAL:'', GRAND_SOL_TOTAL:0, INVENTORY_ID:'',
                }
  closingData = { RunNo: '', DateTime: '',
                  Action_By: '',
                } 
  closingData1: any;
  userRunNo: any;

  public errorMessage: any = "";
  public errorMessage2: any = "";
  public pages: Array<{title: string, component: any, class:any, icon:string}>;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public menuCtrl:MenuController,public sidemenu:ServiceSidemenuProvider, 
              public serviceapi: ServiceApiProvider, private formBuilder: FormBuilder,
              private toastCtrl: ToastController, public loadingCtrl: LoadingController,
              public events: Events, public storage: Storage, public servicegvariable:ServiceGvariableProvider,
              public alertCtrl : AlertController, private alertController:AlertController,) {

    this.todo = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });

//    this.checkInternet();                 //check internet connection

    if (this.servicegvariable.InternetConnection == 'Online')
    {
      console.log(this.servicegvariable.InternetConnection)
      if(sessionStorage.getItem("token") != null){          //if have login memory

        this.userId = sessionStorage.getItem('userid');     //user ID

        let tbl = ["USER"];
        let column = ["USER_ID"];
        let value = [this.userId];
        
        let tblkey = ["GRP_ID","CORP_ID"];
        let fktbl = ["USER_GRP","CORPORATE"];
        let fkkey = ["GRP_ID","CORP_ID"];


        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        this.showLoader();

        this.loginAttempt(json_data);
      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad A01LoginPage');
  }

  ionViewWillEnter() {
    // Disable the split plane in this page
       this.sidemenu.setSplitPane(false);
       this.menuCtrl.swipeEnable(false);
     }
   
  ionViewDidLeave() {
// Enable it again when leaving the page
    this.sidemenu.setSplitPane(true);
    this.menuCtrl.swipeEnable(true);
  }
  login()
  {
    
    if (this.servicegvariable.InternetConnection == 'Online')
    {
      this.showLoader();
      let tbl = ["USER","USER"];
      let column = ["USER_NAME","PASSWORD"];
      let value = [this.loginData.USER_NAME,this.loginData.PASSWORD];
      
      let tblkey = ["GRP_ID","CORP_ID"];
      let fktbl = ["USER_GRP","CORPORATE"];
      let fkkey = ["GRP_ID","CORP_ID"]; 

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.loginAttempt(json_data);
    }
    else {
      console.log('offline login');
      this.errorMessage = "";
      this.errorMessage2 = "";
      let f_loading = 0;
      this.storage.get('userData').then((data) => {
        this.userData = data;
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
              
            let dataU = JSON.parse(this.userData[i]);
            console.log(dataU)
            for (let i=0; i<dataU.length; i++){
              if (this.loginData.USER_NAME == dataU[i].USER_NAME){
                f_loading = 1;
                var result = Bcryptjs.compareSync(this.loginData.PASSWORD, dataU[i].PASSWORD); // compare encrypt password

                if (result == true){

                  if (dataU[i].USER_ACTIVE == "YES") {
                    console.log(dataU[i]);
                    
                    
                    this.storage.get('closingData').then((data) => {
                      let otherUserClosing = 0;
                      let userClosingID = '';
                      let userClosingName = '';
                      this.closingData = data;
                      this.closingData1 = data;
                      this.errorMessage ='';
                
                      if (dataU[i].GRP_ID == "5"){                       //checking for cashier
                        if (data && data.length > 0) {
      
                          console.log('Closing data is not empty.');
                          let data_length = this.closingData1.length;
          
                          for (let x=0; x<data_length; x++){
                    
                            let data1 = this.closingData[x];
                            console.log(data1);
                            if (data1.Action_By != dataU[i].USER_ID){
                              
                              otherUserClosing = 1;                     //found clsoing data by other user ID
                              userClosingID = data1.Action_By;
                              console.log("In here", userClosingID, dataU[i].USER_ID)
                            }
                          }
                        }
                      }
                      if (otherUserClosing != 1){
                        console.log('walaoeh')
                        sessionStorage.setItem('token', 'mobil');                         //store for limited time
                        sessionStorage.setItem('userid', dataU[i].USER_ID);
                        sessionStorage.setItem('username', dataU[i].USER_NAME);
                        sessionStorage.setItem('userbranchid', this.offlineBranchID);
                        sessionStorage.setItem('useractive', dataU[i].USER_ACTIVE);
                        sessionStorage.setItem('usergroupid', dataU[i].GRP_ID);
                        /* sessionStorage.setItem('usergroupname', data[i].GRP_NAME); */
                        sessionStorage.setItem('usercorpid', dataU[i].CORP_ID);
                        /* sessionStorage.setItem('usercorpname', data[i].CORP_NAME); */
                        this.userGrpId = dataU[i].GRP_ID;

                        //=====save last SO NO===========================
                        if (this.f_offlineData == 1){
                          this.userId = dataU[i].USER_ID;
                          this.temp_SO_NO = dataU[i].USER_RUNNO;
                          this.temp_SO_NO2 = dataU[i].USER_RUNNO2;
                          this.temp_SO_NO3 = dataU[i].USER_RUNNO3;  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
                          
                          // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
                          /*this.SO_USER_ID = this.pad_with_zeroes(this.userId, 4);
                          this.SO_SO_NO = this.pad_with_zeroes(this.temp_SO_NO, 10);                //add zero infront to make it 10 digit
                          this.SO_NO = 'S' + this.SO_USER_ID + 'A' + this.SO_SO_NO;*/
                          
                          // [YOW:22/07/2020:CR/MPOS/20-03]:Added (Save only when server number is bigger)
                          this.storage.get('lastLocalRunNo').then((data) => {
                            if (data && data.length > 0) {
                              let temp = data;
                              if (this.temp_SO_NO > temp) {
                                this.SO_NO = ' '+this.temp_SO_NO;

                                let val3 = JSON.stringify(this.SO_NO);    //save last SO_NO
                                this.storage.set('lastSO_NO', val3);
                              }
                            }
                            else {
                              this.SO_NO = ' '+ this.temp_SO_NO;

                              let val3 = JSON.stringify(this.SO_NO);    //save last SO_NO
                              this.storage.set('lastSO_NO', val3); 
                            }
                          });
            
                          //duplicate for fleet card sales number
                          // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
                          /*this.SO_SO_NO2 = this.pad_with_zeroes(this.temp_SO_NO2, 10);              //add zero infront to make it 10 digit
                          this.SO_NO2 = 'CS' + this.SO_USER_ID + 'A' + this.SO_SO_NO2;*/

                          // [YOW:22/07/2020:CR/MPOS/20-03]:Added (Save only when server number is bigger)
                          this.storage.get('lastLocalRunNo2').then((data) => {
                            if (data && data.length > 0) {
                              let temp = data;
                              if (this.temp_SO_NO2 > temp) {
                                this.SO_NO2 = ' '+ this.temp_SO_NO2;
            
                                let val4 = JSON.stringify(this.SO_NO2);   //save last SO_NO2
                                this.storage.set('lastSO_NO2', val4);
                              }
                            }
                            else {
                              this.SO_NO2 = ' '+ this.temp_SO_NO2;
            
                              let val4 = JSON.stringify(this.SO_NO2);   //save last SO_NO2
                              this.storage.set('lastSO_NO2', val4);
                            }
                          });

                          // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
                          // [CXY:10/08/2020:CR/MPOS/20-03]:Comment
                          /*this.SO_SO_NO3 = this.pad_with_zeroes(this.temp_SO_NO3, 10);
                          this.SO_NO3 = 'GS' + this.SO_USER_ID + 'A' + this.SO_SO_NO3;*/
                          // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added
                          
                          // [CXY:10/08/2020:CR/MPOS/20-03]:Added
                          this.storage.get('lastLocalRunNo3').then((data) => {
                            if (data && data.length > 0 && data) {
                              let temp = data;
                              if (this.temp_SO_NO3 > temp) {
                                this.SO_NO3 = ' '+ this.temp_SO_NO3;

                                let val5 = JSON.stringify(this.SO_NO3);   //save last SO_NO3
                                this.storage.set('lastSO_NO3', val5);
                              }
                            }
                            else {
                              this.SO_NO3 = ' '+ this.temp_SO_NO3;
            
                              let val5 = JSON.stringify(this.SO_NO3);   //save last SO_NO3
                              this.storage.set('lastSO_NO3', val5);
                            }
                          });

                          /* this.userRunNo = 0;
                          let val2 = JSON.stringify(this.userRunNo);
                          this.storage.set('runningNoData', val2); */
                        }
                        //================================

                        this.storage.get('groupAccessData').then((data) => {
                          this.userGrpAccessData = data;

                          if (data && data.length > 0) {
                            for (let i=0; i<data.length; i++){
                                
                              let data = JSON.parse(this.userGrpAccessData[i]);

                              for (let i=0; i<data.length; i++){
                                if (this.userGrpId == data[i].GRP_ID){
                                  this.userAccessId.push(data[i].ACCESS_ID);
                                }
                              }
                            }
                            sessionStorage.setItem('useraccessid', this.userAccessId);
                            this.events.publish('user:created', this.userName, this.userAccessId, Date.now());  //create GRP_ID in events, for filter side menu item

                            //Different first page based on group ID
                            if ((this.userGrpId == "1") || (this.userGrpId == "2") || (this.userGrpId == "3") || (this.userGrpId == "5"))  //system admin, branch admin, manager & cashier 
                            {
                              console.log(this.userAccessId);               
                                                                            //setroot page change to app.component

                            }      
                            else {
                              this.errorMessage2 = "Unauthorized access to POS.";
                              this.errorMessage ='';
                              sessionStorage.clear();                       //clear temporary user data
                            }
                          }
                        });
                      }
                      else {
                        this.storage.get('userData').then((data) => {
                          this.userData = data;
                          if (data && data.length > 0) {
                            for (let i=0; i<data.length; i++){
                                
                              let data = JSON.parse(this.userData[i]);
                              console.log(data)
                              
                              for (let i=0; i<data.length; i++){
                                if (userClosingID == data[i].USER_ID){
                                  userClosingName = data[i].USER_NAME;
                                }
                              }
                            }
                          }
                          console.log(userClosingName)
                          if (userClosingName!=''){
                            this.errorMessage2 = "Login Failed. Sales for " + userClosingName + " not close. Please login " + userClosingName + " to do closing.";
                            this.errorMessage ='';
                          }
                          else {
                            this.errorMessage2 = "Login Failed. Sales for other user not close.";
                            this.errorMessage ='';
                          }
                        });
                      }

                      if (i == (dataU.length - 1)){
                        console.log(dataU.length)
                        if(sessionStorage.getItem("token") == null){                      //login not success
                          if (this.errorMessage2 == ""){
                            this.errorMessage = "Login Failed. Username is incorrect.";
                          }
                          else if (this.errorMessage != ""){
                            this.errorMessage = ''
                          }
                        }
                      }
                    });
                  }
                  else {
                    this.errorMessage2 = "Login Failed. This username is blocked.";
                    this.errorMessage ='';
                  }
                }
                else {
                  this.errorMessage2 = "Login Failed.Password is incorrect.";
                  this.errorMessage ='';
                }

              }
              else {
                 if (i == (dataU.length - 1)){
                  console.log(dataU.length)
                  if (f_loading != 1){
                    if(sessionStorage.getItem("token") == null){                      //login not success

                        this.errorMessage = "Login Failed. Username is incorrect.";

                    }
                  }
                } 
              }
            }
          }
        }
      });
    }
  }

  cancel(){
    this.loginData.USER_NAME = ""; 
    this.loginData.PASSWORD = ""; 
    this.errorMessage = "";
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Authenticating...',
        duration: 5000,
    });

    this.loading.present();
  }
  showLoader2(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });

    this.loading.present();
  }
    
  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom',
      dismissOnPageChange: true
    });

    toast.present();
  }

  loginAttempt(json_data){
    this.errorMessage = "";

    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Message"]);
      
      if (this.Status == "1"){
        
        let Records = result["Records"];
        this.userId = Records[0]["USER_ID"];
        this.userName = Records[0]["USER_NAME"];
        this.userBranchId = Records[0]["BRANCH_ID"];
        this.userActive = Records[0]["USER_ACTIVE"];
        this.userGrpId = Records[0]["GRP_ID"];
        this.userGrpName = Records[0]["GRP_NAME"];
        this.userCorpId = Records[0]["CORP_ID"];
        this.userCorpName = Records[0]["CORP_NAME"];
        /*this.temp_SO_NO = Records[0]["USER_RUNNO"];
        this.temp_SO_NO2 = Records[0]["USER_RUNNO2"];*/
        
        if (this.userActive == "YES") {
            
          this.storage.get('closingData').then((data) => {
            let otherUserClosing = 0;
            let userClosingID = '';
            let userClosingName = '';
            this.closingData = data;
            this.closingData1 = data;
      
            if (this.userGrpId == "5"){                       //checking for cashier
              if (data && data.length > 0) {
      
                console.log('Closing data is not empty.');
                let data_length = this.closingData1.length;

                for (let i=0; i<data_length; i++){
          
                  let data1 = this.closingData[i];
                  if (data1.Action_By != this.userId){

                    otherUserClosing = 1;                     //found clsoing data by other user ID
                    userClosingID = data1.Action_By;
                  }
                }
              }
            }
            console.log(otherUserClosing, this.f_offlineData);
            if (otherUserClosing != 1){

              sessionStorage.setItem('token', 'mobil');                         //store for limited time
              sessionStorage.setItem('userid', this.userId);
              sessionStorage.setItem('username', this.userName);
              sessionStorage.setItem('userbranchid', this.userBranchId);
              sessionStorage.setItem('useractive', this.userActive);
              sessionStorage.setItem('usergroupid', this.userGrpId);
              sessionStorage.setItem('usergroupname', this.userGrpName);
              sessionStorage.setItem('usercorpid', this.userCorpId);
              sessionStorage.setItem('usercorpname', this.userCorpName);

              //=====save last SO NO===========================
              if (this.f_offlineData == 1){
                console.log('walaoeh')
                this.storage.get('userData').then((data) => {
                  this.userData = data;
                  if (data && data.length > 0) {
                    for (let i=0; i<data.length; i++){
                        
                      let dataU = JSON.parse(this.userData[i]);
                      console.log(dataU)
                      for (let i=0; i<dataU.length; i++){
                        if (this.loginData.USER_NAME == dataU[i].USER_NAME){
                          this.userId = dataU[i].USER_ID;
                          this.temp_SO_NO = dataU[i].USER_RUNNO;
                          this.temp_SO_NO2 = dataU[i].USER_RUNNO2;
                          this.temp_SO_NO3 = dataU[i].USER_RUNNO3;  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
                          
                          // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
                          /*this.SO_USER_ID = this.pad_with_zeroes(this.userId, 4);
                          this.SO_SO_NO = this.pad_with_zeroes(this.temp_SO_NO, 10);                //add zero infront to make it 10 digit
                          this.SO_NO = 'S' + this.SO_USER_ID + 'A' + this.SO_SO_NO;*/

                          // [YOW:22/07/2020:CR/MPOS/20-03]:Added (Save only when server number is bigger)
                          this.storage.get('lastLocalRunNo').then((data) => {
                            if (data && data.length > 0) {
                              let temp = data;
                              if (this.temp_SO_NO > temp) {
                                this.SO_NO = ' '+ this.temp_SO_NO;
                                
                                let val3 = JSON.stringify(this.SO_NO);    //save last SO_NO
                                this.storage.set('lastSO_NO', val3);
                              }
                            }
                            else {
                              this.SO_NO = ' '+ this.temp_SO_NO;

                              let val3 = JSON.stringify(this.SO_NO);    //save last SO_NO
                              this.storage.set('lastSO_NO', val3); 
                            }
                          });
  
                          //duplicate for fleet card sales number
                          // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
                          /*this.SO_SO_NO2 = this.pad_with_zeroes(this.temp_SO_NO2, 10);                //add zero infront to make it 10 digit
                          this.SO_NO2 = 'CS' + this.SO_USER_ID + 'A' + this.SO_SO_NO2;*/

                          // [YOW:22/07/2020:CR/MPOS/20-03]:Added (Save only when server number is bigger)
                          this.storage.get('lastLocalRunNo2').then((data) => {
                            if (data && data.length > 0) {
                              let temp = data;
                              if (this.temp_SO_NO2 > temp) {
                                this.SO_NO2 = ' '+ this.temp_SO_NO2;
            
                                let val4 = JSON.stringify(this.SO_NO2);   //save last SO_NO2
                                this.storage.set('lastSO_NO2', val4);
                              }
                            }
                            else {
                              this.SO_NO2 = ' '+ this.temp_SO_NO2;
            
                              let val4 = JSON.stringify(this.SO_NO2);   //save last SO_NO2
                              this.storage.set('lastSO_NO2', val4);
                            }
                          });

                          // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
                          // [CXY:10/08/2020:CR/MPOS/20-03]:Comment
                          /*this.SO_SO_NO3 = this.pad_with_zeroes(this.temp_SO_NO3, 10);
                          this.SO_NO3 = 'GS' + this.SO_USER_ID + 'A' + this.SO_SO_NO3;*/
                          // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added

                          // [CXY:10/08/2020:CR/MPOS/20-03]:Added
                          this.storage.get('lastLocalRunNo3').then((data) => {
                            if (data && data.length > 0) {
                              let temp = data;
                              if (this.temp_SO_NO3 > temp) {
                                this.SO_NO3 = ' '+ this.temp_SO_NO3;

                                let val5 = JSON.stringify(this.SO_NO3);   //save last SO_NO3
                                this.storage.set('lastSO_NO3', val5);
                              }
                            }
                            else {
                              this.SO_NO3 = ' '+ this.temp_SO_NO3;
            
                              let val5 = JSON.stringify(this.SO_NO3);   //save last SO_NO3
                              this.storage.set('lastSO_NO3', val5);
                            }
                          });

                          /* this.userRunNo = 0;
                          let val2 = JSON.stringify(this.userRunNo);
                          this.storage.set('runningNoData', val2); */
                        }
                      }
                    }
                  }
                });
              }
              //================================

              let tbl = ["USER_GRP_ACCESS"];
              let column = ["GRP_ID"];
              let value = [this.userGrpId];
              
              let tblkey = ["ACCESS_ID"];
              let fktbl = ["USER_ACCESS"];
              let fkkey = ["ACCESS_ID"];

              let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
              let mydata = Object.assign(jsonitem);
              let json_data = this.serviceapi.json_readdata(mydata,"1");

              //read access level
              this.serviceapi.readdata(json_data,"USER_GRP_ACCESS","1","1").then((result) => {
                this.loading.dismiss();
                this.Status = result["Message"];
                let Records = result["Records"];
                
                if (this.Status == "1"){
                    let rxData = result["RXData"];
                    this.numberData = rxData;
                }
                else {
                  this.numberData = 0;
                }

                for (let i=0; i<=(this.numberData-1); i++)       //store ACCESS_ID
                {
                    this.userAccessId.push(Records[i]["ACCESS_ID"]);
                } 

                sessionStorage.setItem('useraccessid', this.userAccessId);
                this.events.publish('user:created', this.userName, this.userAccessId, Date.now());  //create GRP_ID in events, for filter side menu item

                //Different first page based on group ID
                if ((this.userGrpId == "1") || (this.userGrpId == "2") || (this.userGrpId == "3") || (this.userGrpId == "5"))  //system admin, branch admin, manager & cashier 
                {
                  console.log(this.userAccessId);               
                                                                //setroot page change to app.component

                }      
                else {
                  this.errorMessage = "Unauthorized access to POS.";
                  sessionStorage.clear();                       //clear temporary user data
                }

              }, (err) => {
                this.errorMessage = "Login Error. Please try again. Error Code: '" + err + "'";
                this.loading.dismiss();
              });
            }
            else {
              this.storage.get('userData').then((data) => {
                this.userData = data;
                if (data && data.length > 0) {
                  for (let i=0; i<data.length; i++){
                      
                    let data = JSON.parse(this.userData[i]);
                    console.log(data)
                    
                    for (let i=0; i<data.length; i++){
                      if (userClosingID == data[i].USER_ID){
                        userClosingName = data[i].USER_NAME;
                      }
                    }
                  }
                }
                console.log(userClosingName)
                if (userClosingName!=''){
                  this.errorMessage = "Login Failed. Sales for " + userClosingName + " not close. Please login " + userClosingName + " to do closing.";
                  this.loading.dismiss();
                }
                else {
                  this.errorMessage = "Login Failed. Sales for other user not close.";
                  this.loading.dismiss();
                }
              });
              
            }
          });
        }
        else {
            this.errorMessage = "Login Failed. This username is blocked.";
            this.loading.dismiss();
        }
      }
      else {
        this.errorMessage = "Login Failed. Username or password is incorrect.";
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Login Error. Please try again. Error Code: '" + err + "'";
        if (err == 'TimeoutError: Timeout has occurred'){
          this.loading.dismiss();
          this.checkInternet();
        }
        else {
          this.loading.dismiss();
        }
    }); 
  }

  pad_with_zeroes(number, length) {                                   //routine to add 0 infront number

    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }

    return my_string;
  }

  Prompt()
  {
    this.errorMessage = "";
    if (this.servicegvariable.InternetConnection == 'Online')
    {
      let tbl = ["All"];
      let column = ["All"];
      let value = ["All"];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"]; 

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader2();

      this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];        
        if (this.Status == "1"){
          let Records = result["Records"];
          this.branchArr = Records;
          this.branchItems = this.branchArr;
          this.overlayHidden = false;
        }
        else {
          this.errorMessage = "No branch info.";
        }
      }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
          this.loading.dismiss();
      });
    }
  }

  hideOverlay()
  {
    this.overlayHidden = true;
  }

  downloadBranch(branchID){
    this.offlineBranchID = branchID;
    if (this.servicegvariable.InternetConnection == 'Online')
    {
      let tbl = ["INVENTORY","INVENTORY"];
      let column = ["BRANCH_ID","INVENTORY_ACTIVE"];
      let value = [branchID,"YES"];

      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");

      this.showLoader2();
      this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
        
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.inventoryArr = Records;
          this.inventoryItems = this.inventoryArr;

          let tbl = ["All"];
          let column = ["All"];
          let value = ["All"];

          let tblkey = ["GRP_ID","CORP_ID"];
          let fktbl = ["USER_GRP","CORPORATE"];
          let fkkey = ["GRP_ID","CORP_ID"];

          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
          let mydata = Object.assign(jsonitem);
          let json_data = this.serviceapi.json_readdata(mydata,"1");

          this.serviceapi.readdata(json_data,"USER","2","1").then((result) => {
            
            this.Status = result["Message"];
            if (this.Status == '1'){
              
              let Records = result["Records"];
              this.userArr = Records;
              this.userItems = this.userArr;
        
              let tbl = ["All"];
              let column = ["All"];
              let value = ["All"];
              
              let tblkey = ["ACCESS_ID"];
              let fktbl = ["USER_ACCESS"];
              let fkkey = ["ACCESS_ID"];
  
              let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
              let mydata = Object.assign(jsonitem);
              let json_data = this.serviceapi.json_readdata(mydata,"1");
  
              //read access level
              this.serviceapi.readdata(json_data,"USER_GRP_ACCESS","1","1").then((result) => {

                this.Status = result["Message"];
                let Records = result["Records"];
                if (this.Status == "1"){
                  this.userGrpAccessArr = Records;
                  this.userGrpAccessItems = this.userGrpAccessArr;

                  let tbl = ["All"];
                  let column = ["All"];
                  let value = ["All"];

                  let tblkey = ["No"];
                  let fktbl = ["No"];
                  let fkkey = ["No"];
                  
                  let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                  let mydata = Object.assign(jsonitem);
                  let json_data = this.serviceapi.json_readdata(mydata,"1");
                  
                  this.serviceapi.readdata(json_data,"PAYMENT_TYPE","1","1").then((result) => {		
                    this.Status = result["Message"];
                    let Records = result["Records"];
                    if (this.Status == '1') {
                      this.paymentTypeArr = Records;
                      
                      let tbl = ["All"];
                      let column = ["All"];
                      let value = ["All"];

                      let tblkey = ["PAYMENT_TYPE_ID"];
                      let fktbl = ["PAYMENT_TYPE"];
                      let fkkey = ["PAYMENT_TYPE_ID"];

                      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                      let mydata = Object.assign(jsonitem);
                      let json_data = this.serviceapi.json_readdata(mydata,"1");
                      
                      this.serviceapi.readdata(json_data,"PAYMENT_SUB_TYPE","1","1").then((result) => {
                        this.Status = result["Message"];
                        if (this.Status == "1") {
                          let Records = result["Records"];
                          this.paymentSubTypeArr = Records;

                          let tbl = ["All"];
                          let column = ["All"];
                          let value = ["All"];
                          
                          let tblkey = ["CORP_ID"];
                          let fktbl = ["CORPORATE"];
                          let fkkey = ["CORP_ID"];

                          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                          let mydata = Object.assign(jsonitem);
                          let json_data = this.serviceapi.json_readdata(mydata,"1");

                          this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
                            this.Status = result["Message"];
                            if (this.Status == "1" || this.Status == "4"){
                              let Records = result["Records"];
                              this.cardArr = Records;
                              console.log(this.cardArr)

                              let tbl = ["All"];
                              let column = ["All"];
                              let value = ["All"];
                              
                              let tblkey = ["BRANCH_ID", "INVENTORY_ID"];
                              let fktbl = ["BRANCH", "INVENTORY"];
                              let fkkey = ["BRANCH_ID", "INVENTORY_ID"];
    
                              let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                              let mydata = Object.assign(jsonitem);
                              let json_data = this.serviceapi.json_readdata(mydata,"1");
    
                              this.serviceapi.readdata(json_data,"INVENTORY_LEVEL","1","1").then((result) => {
                                this.Status = result["Message"];
                                if (this.Status == "1" || this.Status == "4"){
                                  let Records = result["Records"];
                                  this.inventoryLevelArr = Records;             //get inventory level and keep in local for checking during sales
                                  console.log(this.inventoryLevelArr)

                                  let val = JSON.stringify(this.branchArr);
                                  this.storage.get('branchData').then((data) => {
                                    let array = [];
                                    array.push(val);
                                    this.storage.set('branchData', array);                        //store branch arr
                                  });
            
                                  let val2 = JSON.stringify(this.inventoryArr);
                                  this.storage.get('inventoryData').then((data) => {
                                    let array = [];
                                    array.push(val2);
                                    this.storage.set('inventoryData', array);                   //store inventory arr
                                  });
            
                                  let val3 = JSON.stringify(this.userArr);
                                  this.storage.get('userData').then((data) => {
                                    let array = [];
                                    array.push(val3);
                                    this.storage.set('userData', array);                        //store user arr
                                  });
            
                                  let val4 = JSON.stringify(this.userGrpAccessArr);
                                  this.storage.get('groupAccessData').then((data) => {
                                    let array = [];
                                    array.push(val4);
                                    this.storage.set('groupAccessData', array);                //store group access arr
                                  });
            
                                  let val5 = parseFloat(this.offlineBranchID);
                                  this.storage.get('offlineBranchData').then((data) => {
                                    let array = 0;
                                    array = val5;
                                    this.storage.set('offlineBranchData', array);              //store offline branch data
                                  });
            
                                  let val6 = JSON.stringify(this.paymentTypeArr);
                                  this.storage.get('paymentTypeData').then((data) => {
                                    let array = [];
                                    array.push(val6);
                                    this.storage.set('paymentTypeData', array);                //store payment type arr
                                  });

                                  let val7 = JSON.stringify(this.paymentSubTypeArr);
                                  this.storage.get('paymentSubTypeData').then((data) => {
                                    let array = [];
                                    array.push(val7);
                                    this.storage.set('paymentSubTypeData', array);             //store payment sub type arr
                                  });

                                  let val8 = JSON.stringify(this.cardArr);
                                  this.storage.get('cardData').then((data) => {
                                    let array = [];
                                    array.push(val8);
                                    this.storage.set('cardData', array);                       //store card arr
                                  });

                                  let val9 = JSON.stringify(this.inventoryLevelArr);
                                  this.storage.get('inventoryLevelData').then((data) => {
                                    let array = [];
                                    array.push(val9);
                                    this.storage.set('inventoryLevelData', array);             //store invnetory level arr
                                  });

                                  this.f_offlineData = 1;
                                  console.log(this.f_offlineData);
            
                                  this.overlayHidden = true;
                                  this.loading.dismiss();
                                  
                                  let alert = this.alertCtrl.create({                                                         //authorization number should not be null
                                    title: 'Download Successful',
                                    message: 'Offline data download successful.',
                                    buttons: [
                                      {
                                        text: 'OK',
                                      }
                                    ]
                                  });
                                  alert.present();
                                }
                                else {
                                  this.errorMessage = "Inventory data error";
                                  this.loading.dismiss();
                                }
                              }, (err) => {
                                this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                                this.loading.dismiss();
                            });
                            }
                            else {
                              this.errorMessage = "Card data error";
                              this.loading.dismiss();
                            }
                          }, (err) => {
                              this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                              this.loading.dismiss();
                          });
                        }
                        else {
                          this.errorMessage = "Payment sub type data error";
                          this.loading.dismiss();
                        }
                      }, (err) => {
                        this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                        this.loading.dismiss();
                      });
                    }
                    else {
                      this.errorMessage = "Payment type data error.";
                      this.loading.dismiss();
                    }
                  }, (err) => {
                    this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                    this.loading.dismiss();
                  });
                }
                else {
                  this.errorMessage = "User group access data error.";
                  this.loading.dismiss();
                }
              }, (err) => {
                this.errorMessage = "Login Error. Please try again. Error Code: '" + err + "'";
                this.loading.dismiss();
              });
            }
            else {
              this.errorMessage = "User data error.";
              this.loading.dismiss();
            }
          }, (err) => {
            this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
            this.loading.dismiss();
          });
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
        this.loading.dismiss();
      });
    }
    else{
      let addToDoAlert = this.alertController.create({
        title:"Offline",
        message:"No internet connection.",
        buttons:[
          {
            text:"OK"
          }]
      });
      addToDoAlert.present();
    }
  }

  checkInternet(){
    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];

    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");

    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {

        this.servicegvariable.InternetConnection = 'Online';
        let confirm = this.alertCtrl.create({
          title: 'Online',
          message: 'Retry login.',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: data => {
                //console.log('Cancel clicked');    //no proceed

              }
            },
            {
              text: 'Retry',
              handler: () => {
                console.log('Agree clicked');
                this.showLoader();
                let tbl = ["USER","USER"];
                let column = ["USER_NAME","PASSWORD"];
                let value = [this.loginData.USER_NAME,this.loginData.PASSWORD];
                
                let tblkey = ["GRP_ID","CORP_ID"];
                let fktbl = ["USER_GRP","CORPORATE"];
                let fkkey = ["GRP_ID","CORP_ID"]; 

                let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                let mydata = Object.assign(jsonitem);
                let json_data = this.serviceapi.json_readdata(mydata,"1");
                this.loginAttempt(json_data);
              }
            }
          ],
          enableBackdropDismiss : false
        });
        confirm.present();
      
    }, (err) => {
      console.log("online offline")
      

        this.servicegvariable.InternetConnection = 'Offline';
        let confirm = this.alertCtrl.create({
          title: 'Offline',
          message: 'No internet connection. Please try again.',
          buttons: [
            {
              text: 'Confirm',
              handler: () => {
              console.log('Agree clicked');
              }
            }
          ]
        });
        confirm.present();
       
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/a01-login/a01-login.ts